import { Component, Input, HostBinding, ChangeDetectionStrategy } from '@angular/core';
var NglDay = (function () {
    function NglDay() {
    }
    Object.defineProperty(NglDay.prototype, "label", {
        get: function () {
            return this.day < 10 ? "0" + this.day : this.day;
        },
        enumerable: true,
        configurable: true
    });
    NglDay.decorators = [
        { type: Component, args: [{
                    selector: 'td[nglDay]',
                    template: "\n    <span class=\"slds-day\">{{ label }}</span>\n  ",
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: {
                        'role': 'gridcell',
                    },
                },] },
    ];
    /** @nocollapse */
    NglDay.ctorParameters = function () { return []; };
    NglDay.propDecorators = {
        'day': [{ type: Input, args: ['nglDay',] },],
        'nglDayDisabled': [{ type: HostBinding, args: ['class.slds-disabled-text',] }, { type: HostBinding, args: ['attr.aria-disabled',] }, { type: Input },],
        'nglDaySelected': [{ type: HostBinding, args: ['class.slds-is-selected',] }, { type: HostBinding, args: ['attr.aria-selected',] }, { type: Input },],
    };
    return NglDay;
}());
export { NglDay };
//# sourceMappingURL=day.js.map